import React, { useState } from "react";

const initialFollowers = Array.from({ length: 12 }, (_, index) => ({
  id: index,
  name: "Rahul Sharma",
  location: "Mumbai",
  imgSrc: require("../../assets/SellerDashboard/SellerFollowings/Ellipse.jpg"),
}));

const SellerFollowers = () => {
  const [followers, setFollowers] = useState(initialFollowers);

  const handleRemove = (id) => {
    setFollowers(followers.filter((follower) => follower.id !== id));
  };

  return (
    <>
      {/* <div className="w-full h-[1000px] flex items-center justify-center"> */}
      <div className="w-[1014px] h-[935px] bg-[#FFF9F2] rounded-r-[10px] pt-[36px] px-[28px] pb-[28px] flex flex-col">
        <div className="w-full items-center justify-between flex flex-row">
          <h3 className="w-[77px] h-[24px] text-black text-start font-semibold text-[16px]">
            Followers
          </h3>
          <p className="w-[158px] text-end h-[24px] text-[#FF6300] font-semibold text-[16px]">
            Total Followers : {followers.length}
          </p>
        </div>
        <hr className="w-[167px] h-[3px] bg-[#FF6300] rounded-full mt-[9px]" />
        <div className="flex flex-wrap w-full h-auto mt-[50px] overflow-y-scroll gap-x-[23px] gap-y-[33px] py-[5px] items-center justify-center">
          {followers.map((follower) => (
            <>
              <div
                key={follower.id}
                className="w-[221px] h-[250px] bg-white rounded-[10px] flex flex-col pt-[30px] px-[52px] pb-[26px] items-center drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)]"
              >
                <img
                  src={follower.imgSrc}
                  alt=""
                  className="w-[50px] h-[50px] rounded-full"
                />
                <h4 className="w-[116px] h-[24px] font-semibold text-[16px] text-center text-black mt-[14px]">
                  {follower.name}
                </h4>
                <div className="flex flex-row gap-x-[5px] items-center justify-center mt-[9px]">
                  <svg
                    width="18"
                    height="19"
                    viewBox="0 0 18 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_608_12169)">
                      <path
                        d="M6.75 8.7085C6.75 9.33839 6.98705 9.94248 7.40901 10.3879C7.83097 10.8333 8.40326 11.0835 9 11.0835C9.59674 11.0835 10.169 10.8333 10.591 10.3879C11.0129 9.94248 11.25 9.33839 11.25 8.7085C11.25 8.07861 11.0129 7.47452 10.591 7.02912C10.169 6.58372 9.59674 6.3335 9 6.3335C8.40326 6.3335 7.83097 6.58372 7.40901 7.02912C6.98705 7.47452 6.75 8.07861 6.75 8.7085Z"
                        stroke="black"
                        stroke-width="1.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M13.2428 13.1866L10.0605 16.5456C9.77924 16.8422 9.39794 17.0088 9.00038 17.0088C8.60282 17.0088 8.22151 16.8422 7.94025 16.5456L4.75725 13.1866C3.91817 12.3008 3.34675 11.1723 3.11527 9.94379C2.88378 8.71525 3.00262 7.44184 3.45676 6.2846C3.91089 5.12735 4.67993 4.13824 5.66661 3.44234C6.6533 2.74644 7.81333 2.375 9 2.375C10.1867 2.375 11.3467 2.74644 12.3334 3.44234C13.3201 4.13824 14.0891 5.12735 14.5433 6.2846C14.9974 7.44184 15.1162 8.71525 14.8847 9.94379C14.6533 11.1723 14.0818 12.3008 13.2428 13.1866Z"
                        stroke="black"
                        stroke-width="1.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_608_12169">
                        <rect width="18" height="19" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  <p className="w-[59px] h-[21px] text-black font-medium text-[14px]">
                    {follower.location}
                  </p>
                </div>
                <button
                  className="w-[79px] h-[42px] rounded-[5px] bg-white font-semibold text-[14px] border mt-[34px]"
                  onClick={() => handleRemove(follower.id)}
                >
                  Remove
                </button>
              </div>
            </>
          ))}
        </div>
      </div>
      {/* </div> */}
    </>
  );
};

export default SellerFollowers;
